export const HAS_NAME_IDS = ["nur_name", "name_telefonnummer"];
export const HAS_PHONE_IDS = ["nur_telefonnummer", "name_telefonnummer"];
export const NO_EMBROIDERY_ID = ["keine_bestickung"];